import React from "react";

const STEPS = [
  {
    n: "01",
    t: "Vision & Feasibility",
    d: "We begin by understanding intent, site realities, budget alignment and regulatory feasibility — before a single line is drawn.",
  },
  {
    n: "02",
    t: "Integrated Design",
    d: "Architecture, engineering and sustainability developed together to guarantee build-quality and complete clarity.",
  },
  {
    n: "03",
    t: "Controlled Execution",
    d: "Dedicated project leadership, defined milestones and strict quality checkpoints across every stage of site work.",
  },
  {
    n: "04",
    t: "Delivery Without Surprises",
    d: "Testing, documentation and final walkthroughs — a clean, disciplined handover that starts your asset’s life right.",
  },
];

const IMG =
  "https://static.prod-images.emergentagent.com/jobs/140329da-214d-4361-8f65-2aa02dd6ca18/images/33a653754c31bb702b59b1121adc3ef4788b5ff482939f0362b126623f1cfe96.png";

export default function Process() {
  return (
    <section
      id="process"
      className="relative py-24 md:py-32 border-t border-white/5"
      data-testid="process-section"
    >
      <div className="absolute inset-0 opacity-20">
        <img
          src={IMG}
          alt=""
          className="w-full h-full object-cover"
          aria-hidden
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-[#0A0A0A]/90 to-[#0A0A0A]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-16">
          <div className="text-[11px] uppercase tracking-[0.4em] text-[#D4AF37] mb-5">
            The Process
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white leading-tight">
            A disciplined path from
            <br />
            <span className="italic text-[#D4AF37]">vision to delivery</span>.
          </h2>
        </div>

        <ol className="relative border-l border-[#2A2A2A] ml-4">
          {STEPS.map((s, i) => (
            <li
              key={s.n}
              className="relative pl-10 pb-16 last:pb-0"
              data-testid={`process-step-${s.n}`}
            >
              <span className="absolute -left-[9px] top-1 w-4 h-4 bg-[#D4AF37]" />
              <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
                <div className="md:col-span-3">
                  <div className="font-serif text-6xl text-[#D4AF37]/70">
                    {s.n}
                  </div>
                </div>
                <div className="md:col-span-9">
                  <h3 className="font-serif text-2xl md:text-3xl text-white mb-3">
                    {s.t}
                  </h3>
                  <p className="text-[#A3A3A3] leading-relaxed max-w-2xl">
                    {s.d}
                  </p>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
